var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('header-logos'),_c('v-container',{staticStyle:{"min-height":"calc(100% - 450px)"}},[_c('router-view')],1),_c('footer-ciat')],1)}
var staticRenderFns = []

export { render, staticRenderFns }